import React from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import PortalPagination from '../../components/PortalPagination';
import PortalSpinner from '../../components/Spinner';
import PortalTableScroller from '../../components/PortalTableScroller';
import { partnersService } from '../../services/partners';
import { canViewPartners, getAccessLabel, isMaster } from '../../utils/access';
import { formatDateTimeDisplay } from '../../utils/date';
import { getErrorMessage } from '../../utils/errorMessage';
import { filterNamedPartners, getDuplicatePartnerMessage, normalizeText } from '../../utils/records';

const acesso = Number(sessionStorage.getItem("tipoAcesso") || 0);
const readOnlyMode = !isMaster(acesso);

class PartnersManage extends React.Component {
    state = {
        datatable: [],
        baseData: [],
        message: '',
        show: false,
        modalShow: false,
        loading: true,
        saving: false,
        sortBy: 'nome-asc',
        id: "",
        userName: "",
        passWord: "",
        email: "",
        hourValue: 0,
        sobrenome: "",
        tel: "",
        tipo: '1',
        page: 1,
        postPerPage: 10
    };

    componentDidMount() {
        this.fetch();
    }

    showError = (error, fallbackMessage = 'Nao foi possivel concluir a operacao.') => {
        this.setState({ show: true, message: getErrorMessage(error, fallbackMessage) });
        setTimeout(() => { this.setState({ show: false }); }, 7000);
    };

    sortPartners = (items, sortBy = this.state.sortBy) => {
        const sortedItems = [...items];

        sortedItems.sort((a, b) => {
            switch (sortBy) {
                case 'nome-desc':
                    return `${b.Nome || ''}`.localeCompare(`${a.Nome || ''}`, 'pt-BR');
                case 'id-asc':
                    return Number(a.idUsuario) - Number(b.idUsuario);
                case 'id-desc':
                    return Number(b.idUsuario) - Number(a.idUsuario);
                case 'nome-asc':
                default:
                    return `${a.Nome || ''}`.localeCompare(`${b.Nome || ''}`, 'pt-BR');
            }
        });

        return sortedItems;
    };

    applyTableState = ({
        baseData = this.state.baseData,
        sortBy = this.state.sortBy
    } = {}) => {
        this.setState({
            baseData,
            datatable: this.sortPartners(baseData, sortBy),
            sortBy,
            page: 1
        });
    };

    fetch = async () => {
        if (!canViewPartners(acesso)) {
            window.open('/', "_self");
            return;
        }

        this.setState({ loading: true });
        const request = readOnlyMode ? partnersService.getList() : partnersService.get();

        request.then(response => {
            if (response.status !== 201) {
                return;
            }

            this.applyTableState({
                baseData: filterNamedPartners(response.data || [])
            });
        }).catch((error) => {
            this.showError(error, 'Nao foi possivel carregar os usuarios.');
        }).finally(() => {
            this.setState({ loading: false });
        });
    };

    cancelEdit() {
        try {
            this.setState({
                id: '',
                userName: '',
                passWord: '',
                email: '',
                hourValue: 0,
                sobrenome: '',
                tel: '',
                tipo: '1',
                modalShow: false,
                saving: false
            });
        } catch (error) {
            this.showError(error);
        }
    }

    saveOrUpdate() {
        try {
            const {
                id,
                userName,
                passWord,
                email,
                hourValue,
                sobrenome,
                tel,
                tipo
            } = this.state;

            if (passWord.indexOf(' ') >= 0) {
                throw new Error('Senha com espacos em branco');
            }

            if (!normalizeText(userName)) {
                throw new Error('Nome obrigatorio.');
            }

            if (!tipo || tipo === '0') {
                throw new Error('Tipo de acesso obrigatorio.');
            }

            if (!id && !normalizeText(passWord)) {
                throw new Error('Senha obrigatoria para novo usuario.');
            }

            const duplicateMessage = getDuplicatePartnerMessage(this.state.baseData, {
                id,
                userName,
                sobrenome,
                tel,
                email
            });

            if (duplicateMessage) {
                throw new Error(duplicateMessage);
            }

            const body = {
                id,
                userName: normalizeText(userName),
                passWord,
                email: normalizeText(email),
                hourValue,
                sobrenome: normalizeText(sobrenome),
                tel: normalizeText(tel),
                tipo
            };

            this.setState({ saving: true });
            const request = id ? partnersService.patch(body, id) : partnersService.post(body);

            request.then((response) => {
                this.setState({
                    show: true,
                    message: response.data.code || response.data || 'Operacao realizada com sucesso!'
                });
                setTimeout(() => { this.setState({ show: false }); }, 7000);
                this.cancelEdit();
                this.fetch();
            }).catch((error) => {
                this.showError(error, id ? 'Nao foi possivel atualizar o usuario.' : 'Nao foi possivel inserir o usuario.');
                this.setState({ saving: false });
            });
        } catch (error) {
            this.showError(error);
        }
    }

    changeUserStatus(id, status) {
        try {
            partnersService.patchStatus({ Status: status ? 'Y' : 'N', Id: id }, id).then(response => {
                const updatedBaseData = this.state.baseData.map((item) => (
                    Number(item.idUsuario) === Number(id)
                        ? { ...item, Ativo: status ? 'Y' : 'N' }
                        : item
                ));

                this.setState({ show: true, message: response.data });
                this.applyTableState({ baseData: updatedBaseData });
                setTimeout(() => { this.setState({ show: false }); }, 7000);
            }).catch(error => {
                this.showError(error, 'Nao foi possivel alterar o status do usuario.');
            });
        } catch (error) {
            this.showError(error);
        }
    }

    edit(data) {
        partnersService.getById(data.idUsuario).then(response => {
            if (response.status !== 201) {
                return;
            }

            const res = response.data[0];

            this.setState({
                id: res.idUsuario,
                userName: res.Nome,
                passWord: '',
                email: res.Email,
                hourValue: res.ValorHora,
                sobrenome: res.Sobrenome,
                tel: res.Telefone,
                tipo: String(res.TipoAcesso || '1'),
                modalShow: true
            });
        }).catch((error) => {
            this.showError(error, 'Nao foi possivel carregar os dados do usuario.');
        });
    }

    renderReadOnlyRow = (item) => (
        <tr key={item.idUsuario}>
            <td className="portal-data-strong">{item.idUsuario}</td>
            <td>{item.Nome}</td>
            <td>{item.Sobrenome}</td>
        </tr>
    );

    renderManageRow = (item) => (
        <tr key={item.idUsuario}>
            <td className="portal-data-strong">{item.idUsuario}</td>
            <td>{item.Nome}</td>
            <td>{item.Sobrenome}</td>
            <td>{item.Telefone || '-'}</td>
            <td>{getAccessLabel(item.TipoAcesso)}</td>
            <td>{item.ValorHora || 0}</td>
            <td>{formatDateTimeDisplay(item.UltimoLogin)}</td>
            <td>{item.Email || '-'}</td>
            <td>
                <Form.Check
                    type="switch"
                    id={`partner-status-${item.idUsuario}`}
                    checked={item.Ativo === 'Y'}
                    onChange={event => this.changeUserStatus(item.idUsuario, event.target.checked)}
                />
            </td>
            <td>
                <Button variant="primary" onClick={() => this.edit(item)}>
                    Editar
                </Button>
            </td>
        </tr>
    );

    render() {
        const { datatable, page, postPerPage, loading, saving } = this.state;
        const totalPages = Math.max(1, Math.ceil(datatable.length / postPerPage));
        const safePage = Math.min(Math.max(page, 1), totalPages);
        const indexOfLastPost = safePage * postPerPage;
        const indexOfFirstPost = indexOfLastPost - postPerPage;
        const currentData = datatable.slice(indexOfFirstPost, indexOfLastPost);
        const activeUsers = datatable.filter((item) => item.Ativo === 'Y').length;

        return (
            <Container fluid className="portal-shell">
                <div className="portal-alert">
                    <Alert show={this.state.show} variant="info" dismissible onClose={() => this.setState({ show: false })}>
                        {this.state.message}
                    </Alert>
                </div>

                <div className="page-header">
                    <div>
                        <h2 className="page-title">Equipe e Usuarios</h2>
                        <p className="page-subtitle">
                            {readOnlyMode
                                ? 'Consulta rapida dos colaboradores para apoio operacional.'
                                : 'Gerencie perfis, disponibilidade da equipe e acessos do portal.'}
                        </p>
                    </div>
                </div>

                <div className="portal-stacked-layout">
                    <div className="portal-stacked-summary">
                        <div className="portal-card portal-section">
                            <span className="portal-card-kicker">Visao geral</span>
                            <div className="portal-overview-grid">
                                <div className="portal-overview-item">
                                    <strong>{loading ? '--' : datatable.length}</strong>
                                    <span>usuarios carregados no portal</span>
                                </div>
                                <div className="portal-overview-item">
                                    <strong>{loading ? '--' : (readOnlyMode ? datatable.length : activeUsers)}</strong>
                                    <span>{readOnlyMode ? 'profissionais listados para consulta' : 'usuarios ativos hoje'}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="portal-card portal-section">
                        <div className="portal-card-header">
                            <div className="portal-card-copy">
                                <span className="portal-card-kicker">Tabela principal</span>
                                <h3 className="portal-card-title">Lista de usuarios</h3>
                                <p className="portal-card-subtitle">
                                    {readOnlyMode
                                        ? 'Modo leitura ativado para visualizacao da equipe.'
                                        : 'Ajuste perfis, habilitacao e dados principais de gestores, cadastro e colaboradores.'}
                                </p>
                            </div>
                            <div className="portal-table-actions">
                                <Button as={Link} to="/" variant="secondary">
                                    Voltar
                                </Button>
                                {readOnlyMode ? null : (
                                    <Button variant="success" onClick={() => { this.setState({ modalShow: true }); }}>
                                        Adicionar
                                    </Button>
                                )}
                            </div>
                        </div>

                        <div className="portal-toolbar">
                            <div className="portal-toolbar-group">
                                <Form.Select
                                    className="portal-select-control"
                                    value={this.state.sortBy}
                                    onChange={(event) => this.applyTableState({ sortBy: event.target.value })}
                                >
                                    <option value="nome-asc">Ordenar: Nome A-Z</option>
                                    <option value="nome-desc">Ordenar: Nome Z-A</option>
                                    <option value="id-desc">Ordenar: ID mais recente</option>
                                    <option value="id-asc">Ordenar: ID mais antigo</option>
                                </Form.Select>
                            </div>
                        </div>

                        {loading ? (
                            <PortalSpinner
                                block
                                label="Carregando usuarios"
                                description="Buscando equipe e acessos do portal."
                            />
                        ) : (
                            <>
                                <PortalTableScroller>
                                    <Table className="portal-table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Nome</th>
                                                <th>Sobrenome</th>
                                                {readOnlyMode ? null : <th>Contato</th>}
                                                {readOnlyMode ? null : <th>Tipo Acesso</th>}
                                                {readOnlyMode ? null : <th>Valor/Hora</th>}
                                                {readOnlyMode ? null : <th>Ultimo Acesso</th>}
                                                {readOnlyMode ? null : <th>Email</th>}
                                                {readOnlyMode ? null : <th>Habilitar</th>}
                                                {readOnlyMode ? null : <th>Acoes</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentData.length ? currentData.map((item) => (
                                                readOnlyMode ? this.renderReadOnlyRow(item) : this.renderManageRow(item)
                                            )) : (
                                                <tr>
                                                    <td colSpan={readOnlyMode ? 3 : 10}>
                                                        <div className="portal-empty-state">Nenhum usuario encontrado.</div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </PortalTableScroller>

                                <div className="portal-pagination">
                                    <PortalPagination
                                        currentPage={safePage}
                                        onPageChange={(pageNumber) => this.setState({ page: pageNumber })}
                                        totalPages={totalPages}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {readOnlyMode ? null : (
                    <Modal className="portal-modal" show={this.state.modalShow} onHide={() => { this.cancelEdit(); }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Usuario</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="portal-form-grid two-columns">
                                <Form.Group>
                                    <Form.Label>ID</Form.Label>
                                    <Form.Control readOnly value={this.state.id} type="text" placeholder="Id" />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Tipo de acesso</Form.Label>
                                    <Form.Select value={this.state.tipo} onChange={item => this.setState({ tipo: item.target.value })}>
                                        <option value="0">Tipo Acesso</option>
                                        <option value="3">Gestor</option>
                                        <option value="2">Cadastro</option>
                                        <option value="1">Colaborador</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                            <div className="portal-form-grid two-columns">
                                <Form.Group>
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control value={this.state.userName} type="text" placeholder="Nome" onChange={item => this.setState({ userName: item.target.value })} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Sobrenome</Form.Label>
                                    <Form.Control value={this.state.sobrenome} type="text" placeholder="Sobrenome" onChange={item => this.setState({ sobrenome: item.target.value })} />
                                </Form.Group>
                            </div>
                            <div className="portal-form-grid two-columns">
                                <Form.Group>
                                    <Form.Label>Telefone</Form.Label>
                                    <Form.Control value={this.state.tel} type="text" placeholder="Telefone" onChange={item => this.setState({ tel: item.target.value })} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control value={this.state.email} type="text" placeholder="Email" onChange={item => this.setState({ email: item.target.value })} />
                                </Form.Group>
                            </div>
                            <div className="portal-form-grid two-columns">
                                <Form.Group>
                                    <Form.Label>Nova senha</Form.Label>
                                    <Form.Control value={this.state.passWord} type="password" placeholder="Nova senha (opcional)" onChange={item => this.setState({ passWord: item.target.value })} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Valor/Hora</Form.Label>
                                    <Form.Control value={this.state.hourValue} type="number" placeholder="Valor" onChange={item => this.setState({ hourValue: item.target.value })} />
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => { this.cancelEdit(); }} disabled={saving}>
                                Fechar
                            </Button>
                            <Button variant="success" onClick={() => { this.saveOrUpdate(); }} disabled={saving}>
                                {saving ? 'Salvando...' : 'Salvar'}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </Container>
        );
    }
}

export default PartnersManage;
